export enum DebitFrequency {
  Repeating,
  OneTime
}